import { createContext, useContext, useEffect, useState } from "react";

export const COLORWAYS = [
  { name: "Hot Pink", hex: "#ff1493", p: "328 100% 54%", s: "180 100% 45%" },
  { name: "Aqua", hex: "#00e5e5", p: "180 100% 45%", s: "328 100% 54%" },
  { name: "Lime", hex: "#b6ff00", p: "77 100% 50%", s: "313 100% 50%" },
  { name: "Silver", hex: "#c8d0dc", p: "216 24% 82%", s: "180 100% 45%" },
  { name: "Purple", hex: "#b026ff", p: "274 100% 57%", s: "180 100% 45%" },
  { name: "Orange", hex: "#ff5e00", p: "22 100% 50%", s: "198 100% 50%" },
  { name: "Yellow", hex: "#f2ff00", p: "63 100% 50%", s: "313 100% 50%" },
  { name: "Toxic", hex: "#39ff14", p: "111 100% 54%", s: "313 100% 50%" },
  { name: "Ice", hex: "#00b3ff", p: "198 100% 50%", s: "328 100% 54%" },
  { name: "Magenta", hex: "#ff00c8", p: "313 100% 50%", s: "180 100% 45%" },
];

const HyperColorContext = createContext(null);
const IDX_KEY = "wiggles_hypercolor";
const UV_KEY = "wiggles_uv";

export function HyperColorProvider({ children }) {
  const [index, setIndex] = useState(() => Number(localStorage.getItem(IDX_KEY)) || 0);
  const [uv, setUv] = useState(() => localStorage.getItem(UV_KEY) === "1");

  useEffect(() => {
    const c = COLORWAYS[index] || COLORWAYS[0];
    const root = document.documentElement;
    root.style.setProperty("--primary", c.p);
    root.style.setProperty("--secondary", c.s);
    root.style.setProperty("--accent", c.s);
    root.style.setProperty("--ring", c.p);
    root.style.setProperty("--hc-hex", c.hex);
    localStorage.setItem(IDX_KEY, String(index));
  }, [index]);

  useEffect(() => {
    document.body.classList.toggle("uv-mode", uv);
    localStorage.setItem(UV_KEY, uv ? "1" : "0");
  }, [uv]);

  const active = COLORWAYS[index] || COLORWAYS[0];
  return (
    <HyperColorContext.Provider value={{ colorways: COLORWAYS, index, setIndex, active, uv, setUv }}>
      {children}
    </HyperColorContext.Provider>
  );
}

export const useHyperColor = () => useContext(HyperColorContext);
